
const patterns = {
  PATTERN_ERA: 'G', // Era 标志符 Era strings. For example: "AD" and "BC"
  PATTERN_YEAR: 'y', // 年
  PATTERN_MONTH: 'M', // 月份
  PATTERN_DAY_OF_MONTH: 'd', // 月份的天数
  PATTERN_HOUR_OF_DAY1: 'k', // 一天中的小时数（1-24）
  PATTERN_HOUR_OF_DAY0: 'H', // 24小时制，一天中的小时数（0-23）
  PATTERN_MINUTE: 'm', // 小时中的分钟数
  PATTERN_SECOND: 's', // 秒
  PATTERN_MILLISECOND: 'S', // 毫秒
  PATTERN_DAY_OF_WEEK: 'E', // 一周中对应的星期，如星期一，周一
  PATTERN_DAY_OF_YEAR: 'D', // 一年中的第几天
  PATTERN_DAY_OF_WEEK_IN_MONTH: 'F', // 一月中的第几个星期(会把这个月总共过的天数除以7,不够准确，推荐用W)
  PATTERN_WEEK_OF_YEAR: 'w', // 一年中的第几个星期
  PATTERN_WEEK_OF_MONTH: 'W', // 一月中的第几星期(会根据实际情况来算)
  PATTERN_AM_PM: 'a', // 上下午标识
  PATTERN_HOUR1: 'h', // 12小时制 ，am/pm 中的小时数（1-12）
  PATTERN_HOUR0: 'K', // 和h类型
  PATTERN_ZONE_NAME: 'z', // 时区名
  PATTERN_ZONE_VALUE: 'Z', // 时区值
  PATTERN_WEEK_YEAR: 'Y', // 和y类型
  PATTERN_ISO_DAY_OF_WEEK: 'u',
  PATTERN_ISO_ZONE: 'X'
}
const week = {
  ch: {
    0: '\u65e5',
    1: '\u4e00',
    2: '\u4e8c',
    3: '\u4e09',
    4: '\u56db',
    5: '\u4e94',
    6: '\u516d'
  },
  en: {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday'
  }
}

const formatTime = date => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

/*
*  是否闰年
**/
function isLeapYear (year) {
  return ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0)
}

/*
*  时间比较
**/
function compareTime (time1, time2) {
  if (Date.parse(time1.replace(/-/g, '/')) > Date.parse(time2.replace(/-/g, '/'))) {
    return 1
  } else if (Date.parse(time1.replace(/-/g, '/')) < Date.parse(time2.replace(/-/g, '/'))) {
    return -1
  } else if (Date.parse(time1.replace(/-/g, '/')) === Date.parse(time2.replace(/-/g, '/'))) {
    return 0
  }
}

/*
*  获取某个月的天数
**/
function getDaysOfMonth (year, month) {
  return [31, (this.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month]
}

/**
 * 日期时间格式化
 * @param {Object} dateTime 需要格式化的日期时间
 * @param {String} pattern 格式化的模式，如yyyy-MM-dd hh(HH):mm:ss.S a k K E D F w W z Z
 */
function formatDate (dateTime, pattern) {
  if ((!dateTime) || (dateTime === null)) {
    return dateTime
  }
  var date = new Date(dateTime)
  if ((!date) || (pattern === '')) {
    return dateTime
  }
  return pattern.replace(/([a-z])\1*/ig, function (matchStr, group1) {
    var replacement = ''
    switch (group1) {
      case patterns.PATTERN_ERA: // G
        break
      case patterns.PATTERN_WEEK_YEAR: // Y
      case patterns.PATTERN_YEAR: // y
        replacement = date.getFullYear()
        break
      case patterns.PATTERN_MONTH: // M
        var month = date.getMonth() + 1
        replacement = (month < 10 && matchStr.length >= 2) ? '0' + month : month
        break
      case patterns.PATTERN_DAY_OF_MONTH: // d
        var days = date.getDate()
        replacement = (days < 10 && matchStr.length >= 2) ? '0' + days : days
        break
      case patterns.PATTERN_HOUR_OF_DAY1: // k(1~24)
        var hours24 = date.getHours()
        replacement = hours24
        break
      case patterns.PATTERN_HOUR_OF_DAY0: // H(0~23)
        var hours23 = date.getHours()
        replacement = (hours24 < 10 && matchStr.length >= 2) ? '0' + hours23 : hours23
        break
      case patterns.PATTERN_MINUTE: // m
        var minutes = date.getMinutes()
        replacement = (minutes < 10 && matchStr.length >= 2) ? '0' + minutes : minutes
        break
      case patterns.PATTERN_SECOND: // s
        var seconds = date.getSeconds()
        replacement = (seconds < 10 && matchStr.length >= 2) ? '0' + seconds : seconds
        break
      case patterns.PATTERN_MILLISECOND: // S
        var milliSeconds = date.getMilliseconds()
        replacement = milliSeconds
        break
      case patterns.PATTERN_DAY_OF_WEEK: // E
        var day = date.getDay()
        replacement = week.ch[day]
        break
      // case patterns.PATTERN_DAY_OF_YEAR: // D
      //   replacement = dayOfTheYear(date)
      //   break
      // case patterns.PATTERN_DAY_OF_WEEK_IN_MONTH: // F
      //   var days = date.getDate()
      //   replacement = Math.floor(days / 7)
      //   break
      // case patterns.PATTERN_WEEK_OF_YEAR: // w
      //   var days = dayOfTheYear(date)
      //   replacement = Math.ceil(days / 7)
      //   break
      // case patterns.PATTERN_WEEK_OF_MONTH: // W
      //   var days = date.getDate()
      //   replacement = Math.ceil(days / 7)
      //   break
      case patterns.PATTERN_AM_PM: // a
        var hoursam = date.getHours()
        replacement = hoursam < 12 ? '\u4e0a\u5348' : '\u4e0b\u5348'
        break
      case patterns.PATTERN_HOUR1: // h(1~12)
        var hours12 = date.getHours() % 12 || 12 // 0转为12
        replacement = (hours12 < 10 && matchStr.length >= 2) ? '0' + hours12 : hours12
        break
      case patterns.PATTERN_HOUR0: // K(0~11)
        var hours10 = date.getHours() % 12
        replacement = hours10
        break
      // case patterns.PATTERN_ZONE_NAME: // z
      //   replacement = getZoneNameValue(date).name
      //   break
      // case patterns.PATTERN_ZONE_VALUE: // Z
      //   replacement = getZoneNameValue(date).value
      //   break
      case patterns.PATTERN_ISO_DAY_OF_WEEK: // u
        break
      case patterns.PATTERN_ISO_ZONE: // X
        break
      default:
        break
    }
    return replacement
  })
}

function getArrayIndexByValue (arraylist, tarvalue) {
  var r = -1
  for (var i = 0, len = arraylist.length; i < len; i++) {
    if (arraylist[i].value === tarvalue) {
      r = i
      break
    }
  }
  return r
}

function getArrayIndex (arraylist, tarvalue) {
  var r = -1
  for (var i = 0, len = arraylist.length; i < len; i++) {
    if (arraylist[i] === tarvalue) {
      r = i
      break
    }
  }
  return r
}

function getDateStr (today, addDayCount) {
  var dd
  if (today) {
    dd = new Date(today)
  } else {
    dd = new Date()
  }
  dd.setDate(dd.getDate() + addDayCount)
  var y = dd.getFullYear()
  var m = dd.getMonth() + 1
  var d = dd.getDate()
  if (m < 10) {
    m = '0' + m
  }
  if (d < 10) {
    d = '0' + d
  }
  return y + '-' + m + '-' + d
}

function json2Form (json) {
  var str = []
  for (var p in json) {
    str.push(encodeURIComponent(p) + '=' + encodeURIComponent(json[p]))
  }
  return str.join('&')
}

function createNonceStr (length) {
  var code = ''
  // eslint-disable-next-line no-array-constructor
  var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z')
  for (var i = 0; i < length; i++) {
    var index = Math.floor(Math.random() * 36)
    code += random[index]
  }
  return code
}

export default {
  formatTime: formatTime,
  getArrayIndexByValue: getArrayIndexByValue,
  getArrayIndex: getArrayIndex,
  json2Form: json2Form,
  createNonceStr: createNonceStr,
  getDateStr: getDateStr,
  isLeapYear: isLeapYear,
  compareTime: compareTime,
  getDaysOfMonth: getDaysOfMonth,
  formatDate: formatDate
}
